import React from "react";
import { UserCardsSc } from "./index.sc";
import { Card } from "react-bootstrap";
function Index(props: any) {
  return (
    <>
      <UserCardsSc>
        <Card
          className="user-detail-card"
          style={{
            backgroundColor: "#F4F4F4",
            color: "#333333",
            padding: "10px 15px",
            border: "none",
            borderRadius: "5px",
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
            width: "100%",
            maxWidth: "500px",
          }}
          onClick={props?.onClick}
        >
          <Card.Title
            style={{
              fontWeight: "bold",
              fontSize: "1.2rem",
              marginBottom: "1rem",

              paddingBottom: "0.5rem",
            }}
          >
            Insytix Employee
          </Card.Title>
          <div style={{ marginBottom: "1rem" }}>
            <span style={{ fontWeight: "bold" }}>Name:</span> {props.UserName}
          </div>
          <div style={{ marginBottom: "1rem" }}>
            <span style={{ fontWeight: "bold" }}>Email:</span> {props?.Email}
          </div>
          <div style={{ marginBottom: "1rem" }}>
            <span style={{ fontWeight: "bold" }}>Phone:</span> {props?.phone}
          </div>
          <div>
            <span style={{ fontWeight: "bold" }}>Role:</span> {props?.role}
          </div>
        </Card>
      </UserCardsSc>
    </>
  );
}

export default Index;
